import { render } from "./yuanquList.vue?vue&type=template&id=1e2885f6&scoped=true"
import script from "./yuanquList.vue?vue&type=script&lang=js"
export * from "./yuanquList.vue?vue&type=script&lang=js"

import "./yuanquList.vue?vue&type=style&index=0&id=1e2885f6&lang=scss&scoped=true"

import exportComponent from "G:\\web2\\豪哥\\盘龙山陵园\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2885f6"]])

export default __exports__